import { useEffect, useState } from 'react';
import { range } from 'lodash';
import { Rate } from 'antd';

import { Star as StarRegular } from '@styled-icons/boxicons-regular';
import { Star as StarSolid } from '@styled-icons/boxicons-solid';

import { StyledRateWrapper } from './styled-rate-input.styles';

const StyledRateInput = ({
  onChange,
  value,
  disabled,
}: {
  onChange?: (value: number) => void;
  value?: number;
  disabled?: boolean;
}) => {
  const [hoveredElements, setHoveredElements] = useState<number[]>([]);
  const [selectedElements, setSelectedElements] = useState<number[]>([]);

  useEffect(() => {
    if (value) {
      setSelectedElements(range(1, value + 1));
    }
  }, [value, setSelectedElements]);

  return (
    <StyledRateWrapper>
      <Rate
        disabled={disabled}
        value={value}
        character={({ index }: any) =>
          (hoveredElements.length ? hoveredElements : selectedElements).some(
            idx => idx === index + 1
          ) ? (
            <StarSolid size={20} />
          ) : (
            <StarRegular size={20} />
          )
        }
        onChange={count => {
          if (onChange) {
            onChange(count);
          }
          setSelectedElements(range(0, count + 1));
        }}
        onHoverChange={count => setHoveredElements(range(0, count + 1))}
      />
    </StyledRateWrapper>
  );
};

export default StyledRateInput;
